import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { collection, addDoc } from 'firebase/firestore';
import '../styles/ClientProfile.css';

// Days + half‐hour options (same as profile)
const daysOfWeek = [
  'Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday'
];
const timeOptions = Array.from({ length: 48 }, (_, i) => {
  const hour = Math.floor(i / 2);
  const minutes = i % 2 === 0 ? 0 : 30;
  return new Date(0, 0, 0, hour, minutes)
    .toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
});
const emptyHours = daysOfWeek.reduce((acc, day) => {
  acc[day.toLowerCase()] = { open: '', close: '' };
  return acc;
}, {});


export default function AddClientPage() {
  const navigate = useNavigate();
  const [saving, setSaving] = useState(false);
  const [client, setClient] = useState({
    name: '',
    generalManager: '',
    phone: '',
    phone2: '',
    email: '',
    email2: '',
    website: '',             // NEW
    manufacturer: '',
    street1: '',
    street2: '',
    city: '',
    state: '',
    zip: '',
    hours: emptyHours,
    notes: '',
  });

  const handleChange = e => {
    const { name, value } = e.target;
    if (name.startsWith('hours.')) {
      const [, dayKey, field] = name.split('.');
      setClient(prev => ({
        ...prev,
        hours: {
          ...prev.hours,
          [dayKey]: {
            ...prev.hours[dayKey],
            [field]: value,
          },
        },
      }));
    } else {
      setClient(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const docRef = await addDoc(collection(db, 'clients'), client);
      navigate(`/clients/${docRef.id}?edit=true`);
    } catch (err) {
      console.error('Failed to create client:', err);
      alert('Error creating client');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="client-profile-container">
      <h1 className="gradient-text" style={{ marginBottom: 40, textAlign: 'center'}}>
        Add New Client
      </h1>

      <div className="client-info-section" style={{ marginBottom: 40 }}>
        {/* General Info */}
        <div className="info-card">
          <h4>General Information</h4>
          <input
            name="name"
            value={client.name}
            onChange={handleChange}
            placeholder="Dealership Name"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="generalManager"
            value={client.generalManager}
            onChange={handleChange}
            placeholder="General Manager"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="phone"
            value={client.phone}
            onChange={handleChange}
            placeholder="Primary Phone"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="phone2"
            value={client.phone2}
            onChange={handleChange}
            placeholder="Secondary Phone"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="email"
            value={client.email}
            onChange={handleChange}
            placeholder="Primary Email"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="email2"
            value={client.email2}
            onChange={handleChange}
            placeholder="Secondary Email"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="website"
            value={client.website}
            onChange={handleChange}
            placeholder="Website"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <select name="manufacturer" value={client.manufacturer || ''} onChange={handleChange} style={{ width: '100%', marginBottom: 8 }}>

              <option value="">Select Manufacturer</option>
              <option>Acura</option><option>Audi</option><option>BMW</option><option>Buick</option><option>Cadillac</option>
              <option>Chevrolet</option><option>CDJR</option><option>Ford</option><option>CDJR/Ford</option><option>GMC</option>
              <option>Honda</option><option>Hyundai</option><option>Infiniti</option><option>Kia</option>
              <option>Lexus</option><option>Lincoln</option><option>Mazda</option><option>Mercedes-Benz</option>
              <option>Mitsubishi</option><option>Nissan</option><option>Nissan/Kia</option><option>Subaru</option><option>Tesla</option>
              <option>Toyota</option><option>Used Vehicles</option><option>Volkswagen</option><option>Volvo</option><option>Other</option>
            </select>

          <h4>Address</h4>
          <input
            name="street1"
            value={client.street1}
            onChange={handleChange}
            placeholder="Street 1"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <input
            name="street2"
            value={client.street2}
            onChange={handleChange}
            placeholder="Street 2"
            style={{ width: '100%', marginBottom: 8 }}
          />
          <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
            <input
              name="city"
              value={client.city}
              onChange={handleChange}
              placeholder="City"
              style={{ flex: 1 }}
            />
            <input
              name="state"
              value={client.state}
              onChange={handleChange}
              placeholder="State"
              style={{ flex: 1 }}
            />
            <input
              name="zip"
              value={client.zip}
              onChange={handleChange}
              placeholder="ZIP"
              style={{ width: 100 }}
            />
          </div>
        </div>

        {/* Hours & Notes */}
        <div className="info-card">
          <h4>Business Hours</h4>
          {daysOfWeek.map(day => {
            const key = day.toLowerCase();
            return (
              <div key={day} style={{ marginBottom: 8 }}>
                <label style={{ display: 'inline-block', width: 80 }}>
                  {day}:
                </label>
                <select
                  name={`hours.${key}.open`}
                  value={client.hours[key].open}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="Closed">Closed</option>
                  {timeOptions.map(t => (
                    <option key={t}>{t}</option>
                  ))}
                </select>
                {client.hours[key].open &&
                  client.hours[key].open !== 'Closed' && (
                    <span style={{ marginLeft: 8 }}>
                      to{' '}
                      <select
                        name={`hours.${key}.close`}
                        value={client.hours[key].close}
                        onChange={handleChange}
                      >
                        <option value="">Select</option>
                        {timeOptions.map(t => (
                          <option key={t}>{t}</option>
                        ))}
                      </select>
                    </span>
                  )}
              </div>
            );
          })}

          <h4>Notes</h4>
          <textarea
            name="notes"
            value={client.notes}
            onChange={handleChange}
            placeholder="Add any client-specific notes…"
            style={{ width: '100%', minHeight: 80 }}
          />
        </div>

        {/* Logos & Assets (handled after creation) */}
        <div className="info-card">
          <h4>Logos & Assets</h4>
          <p style={{ fontStyle: 'italic' }}>
            You can upload logos and additional assets once the client is created.
          </p>
        </div>
      </div>

      {/* Save / Cancel */}
      <div style={{ textAlign: 'center' }}>
        <button onClick={handleSave} disabled={saving}>
          {saving ? 'Creating…' : 'Create Client'}
        </button>
        <button
          onClick={() => navigate('/clients')}
          style={{ marginLeft: 12 }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
